import { render } from "./ComImportButton.vue?vue&type=template&id=6be22a6d&ts=true"
import script from "./ComImportButton.vue?vue&type=script&lang=ts"
export * from "./ComImportButton.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__